import React from 'react';
import { ShieldX, AlertTriangle } from 'lucide-react';
import { Textarea } from '@/components/ui/textarea';
import { OnboardingFormData } from '../OnboardingWizardContent';

interface Props {
  data: OnboardingFormData;
  updateData: (updates: Partial<OnboardingFormData>) => void;
}

const StepDoNotMention: React.FC<Props> = ({ data, updateData }) => {
  return (
    <div className="space-y-6">
      <p className="text-muted-foreground">
        Are there any topics, competitors, services, or information your assistant 
        should avoid discussing? <span className="text-sm">(Optional)</span>
      </p>

      {/* Do Not Mention Textarea */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-foreground flex items-center gap-2">
          <ShieldX className="h-4 w-4 text-brand-teal" />
          Topics to Avoid
        </label>
        <Textarea
          value={data.doNotMention}
          onChange={(e) => updateData({ doNotMention: e.target.value })}
          placeholder="Enter any topics, names, or subjects your assistant should not discuss..."
          rows={6}
        />
      </div>

      {/* Examples */}
      <div className="bg-muted/50 rounded-lg p-4">
        <h4 className="font-medium text-foreground mb-3">Common Examples</h4>
        <ul className="text-sm text-muted-foreground space-y-2">
          <li className="flex items-start gap-2">
            <span className="text-brand-teal">•</span>
            <span>Competitor names or services</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-brand-teal">•</span>
            <span>Specific pricing (if you prefer to quote individually)</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-brand-teal">•</span>
            <span>Former staff or partners</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-brand-teal">•</span>
            <span>Discontinued services</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-brand-teal">•</span>
            <span>Sensitive legal matters</span>
          </li>
        </ul>
      </div>

      <div className="bg-amber-500/10 border border-amber-500/20 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <AlertTriangle className="h-5 w-5 text-amber-600 dark:text-amber-400 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm text-card-foreground">
              <strong>Important:</strong> Your assistant already has built-in governance 
              that prevents it from giving specific advice, making guarantees, or 
              discussing topics outside its training. This section is for additional 
              custom restrictions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepDoNotMention;
